import React from "react"
import { RouteComponentProps } from "@reach/router"
import { IFrame } from "../../integration/iframe"

interface Props extends RouteComponentProps {
  id?: string
}

export const ReferralsPricing: React.FC<Props> = ({ id = `` }) => (
  <>
    <IFrame path={`referrals/${id}/pricing`} />
  </>
)

ReferralsPricing.defaultProps = {
  id: ``,
}
